import fetch from '@/axios/promise';
import  {CONT_URL} from  '@/config/constant';
export function contList(query) {
  return invoke(query,'/contractList','POST');
}
export function selectContractById(query) {
  return invoke(query,'/selectContractById','GET');
}
export function syncContract(query) {
  return invoke(query,'/syncContract','POST');
}
export function updateContStatus(query) {
  return invoke(query,'/updateContStatus','POST');
}
export function stageContractDetail(query) {
  return invoke(query,'/stageContractDetail','GET');
}
//合同审批接口
export function approveContract(query) {
  return invoke(query,'/approveContract','POST');
}
//合同总览
export function contractGroupByContCateCode(query) {
  return invoke(query,'/queryContractGroupByContCateCode','POST');
}
// 调用
function invoke(query,url,method){
  return fetch({
    url: CONT_URL+url,
    method: method,
    params: query
  });
}



// WEBPACK FOOTER //
// ./src/api/contract/contract.js